var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5 14h38v-3.5c0-.275-.225-.5-.5-.5h-37c-.275 0-.5.225-.5.5V14zM5.5 38h37c.275 0 .5-.225.5-.5V15H5v22.5c0 .275.225.5.5.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#C8C6C4",
    cx: 8,
    cy: 12,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#C8C6C4",
    cx: 11,
    cy: 12,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#C8C6C4",
    cx: 14,
    cy: 12,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE9",
    d: "M14 38H5.5a.5.5 0 01-.5-.5V15h9v23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C6C4",
    d: "M11.5 20h-4a.5.5 0 010-1h4a.5.5 0 010 1zM11.5 23h-4a.5.5 0 010-1h4a.5.5 0 010 1zM11.5 26h-4a.5.5 0 010-1h4a.5.5 0 010 1zM26.5 20h-10a.5.5 0 010-1h10a.5.5 0 010 1zM26.5 23h-10a.5.5 0 010-1h10a.5.5 0 010 1zM26.5 26h-10a.5.5 0 010-1h10a.5.5 0 010 1zM26.5 29h-10a.5.5 0 010-1h10a.5.5 0 010 1zM26.5 32h-10a.5.5 0 010-1h10a.5.5 0 010 1zM26.5 35h-10a.5.5 0 010-1h10a.5.5 0 010 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#69AFE5",
    d: "M40.083 35h-9.166c-.507 0-.917-.586-.917-1.308V19.308c0-.723.41-1.308.917-1.308h9.166c.507 0 .917.585.917 1.308v14.384c0 .722-.41 1.308-.917 1.308z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fill: "#605E5C",
    d: "M42.5 9h-37C4.673 9 4 9.673 4 10.5v27c0 .827.673 1.5 1.5 1.5h37c.827 0 1.5-.673 1.5-1.5v-27c0-.827-.673-1.5-1.5-1.5zm-37 1h37c.275 0 .5.225.5.5V14H5v-3.5c0-.275.225-.5.5-.5zm37 28h-37a.501.501 0 01-.5-.5V15h38v22.5c0 .275-.225.5-.5.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExe);
export default __webpack_public_path__ + "static/media/exe.4dd83a54f08f74535105cd451ddaef98.svg";
export { ForwardRef as ReactComponent };